{ "imageTag": "1.54.0-12", "buildUri": "vstfs:///Build/Build/104377", "buildId": "104377", "sourceCommit": "6b60295c0877724adb8e748423b949b86106f769", "sourceBranch": "release/1.54.0", "releaseDate": "2026-11-05T11:26:47Z" }
